export default __webpack_public_path__ + "static/media/hot1.15936775.jpg";